import { AUTH_KEY } from "../../config.js";
import { patch } from "../../state/store.js";

export function logout({ silent = false } = {}) {
  localStorage.removeItem(AUTH_KEY);
  patch({
    userEmail: "",
    authToken: "",
    user: null,
    connectionStatus: "offline",
    view: "login",
    leads: [],
    chats: [],
    chatMessages: {},
    activeChatJid: "",
    whatsappSession: null,
    accounts: [],
    accountFilter: [],
    funnels: [],
    activeFunnelId: "",
  });
  if (!silent && typeof window !== "undefined") {
    console.info("[wcrm] logged out");
  }
}

export function loadAuthFromStorage() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    const auth = JSON.parse(raw);
    if (auth?.token) {
      patch({ userEmail: auth.email || "", authToken: auth.token, user: auth.user || null });
      return auth;
    }
  } catch (_) { /* noop */ }
  return null;
}

export function persistAuth(auth) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
}
